import { createStructuredSelector } from 'reselect';
import {
    COM_CATALOG_LIST, COM_CATALOG_LIST_SUCCESS, COM_CATALOG_LIST_ERROR,
    COM_CATALOG_PAGE_SET, COM_CATALOG_SEARCH_CHANGE,
    COM_CATALOG_ADD_MODAL_SET, COM_CATALOG_ADD_CHANGE,
    COM_CATALOG_ADD, COM_CATALOG_ADD_SUCCESS, COM_CATALOG_ADD_ERROR,
    COM_CATALOG_EDIT_MODAL_SET, COM_CATALOG_EDIT_SET_DATA,
    COM_CATALOG_UPDATE, COM_CATALOG_UPDATE_SUCCESS, COM_CATALOG_UPDATE_ERROR,
    COM_CATALOG_CANCEL_MODAL_SET, COM_CATALOG_CANCEL_SET_DATA,
    COM_CATALOG_DETAIL_LIST, COM_CATALOG_DETAIL_LIST_SUCCESS, COM_CATALOG_DETAIL_LIST_ERROR,
    COM_CATALOG_DETAIL_PAGE_SET,
    COM_CATALOG_DETAIL_ADD_MODAL_SET, COM_CATALOG_DETAIL_ADD_CHANGE,
    COM_CATALOG_DETAIL_ADD, COM_CATALOG_DETAIL_ADD_SUCCESS, COM_CATALOG_DETAIL_ADD_ERROR,
    COM_CATALOG_DETAIL_EDIT_MODAL_SET, COM_CATALOG_DETAIL_EDIT_SET_DATA,
    COM_CATALOG_DETAIL_UPDATE, COM_CATALOG_DETAIL_UPDATE_SUCCESS, COM_CATALOG_DETAIL_UPDATE_ERROR,
    COM_CATALOG_DETAIL_CANCEL_MODAL_SET, COM_CATALOG_DETAIL_CANCEL_SET_DATA,
} from '../../actions';

export const NAME = 'comCatalog';

// Catalog List
export const ComCatalogList = (page, num_page, orderBy, filters) => ({ type: COM_CATALOG_LIST, payload: { page, num_page, orderBy, filters } });
export const ComCatalogListSuccess = (data) => ({ type: COM_CATALOG_LIST_SUCCESS, payload: data });
export const ComCatalogListError = (error) => ({ type: COM_CATALOG_LIST_ERROR, payload: error });
export const ComCatalogPageSet = (data) => ({ type: COM_CATALOG_PAGE_SET, payload: data });
export const ComCatalogSearchChange = (data) => ({ type: COM_CATALOG_SEARCH_CHANGE, payload: data });

// Catalog Add
export const ComCatalogAddModalSet = (data) => ({ type: COM_CATALOG_ADD_MODAL_SET, payload: data });
export const ComCatalogAddChangeSet = (data) => ({ type: COM_CATALOG_ADD_CHANGE, payload: data });
export const ComCatalogAdd = (data) => ({ type: COM_CATALOG_ADD, payload: data });
export const ComCatalogAddSuccess = (data) => ({ type: COM_CATALOG_ADD_SUCCESS, payload: data });
export const ComCatalogAddError = (error) => ({ type: COM_CATALOG_ADD_ERROR, payload: error });

// Catalog Edit
export const ComCatalogEditModalSet = (data) => ({ type: COM_CATALOG_EDIT_MODAL_SET, payload: data });
export const ComCatalogEditSetData = (data) => ({ type: COM_CATALOG_EDIT_SET_DATA, payload: data });
export const ComCatalogUpdate = (data) => ({ type: COM_CATALOG_UPDATE, payload: data });
export const ComCatalogUpdateSuccess = (data) => ({ type: COM_CATALOG_UPDATE_SUCCESS, payload: data });
export const ComCatalogUpdateError = (error) => ({ type: COM_CATALOG_UPDATE_ERROR, payload: error });

// Catalog Cancel (Anular)
export const ComCatalogCancelModalSet = (data) => ({ type: COM_CATALOG_CANCEL_MODAL_SET, payload: data });
export const ComCatalogCancelSetData = (data) => ({ type: COM_CATALOG_CANCEL_SET_DATA, payload: data });

// Catalog Detail List
export const ComCatalogDetailList = (page, num_page, id_catalog) => ({ type: COM_CATALOG_DETAIL_LIST, payload: { page, num_page, id_catalog } });
export const ComCatalogDetailListSuccess = (data) => ({ type: COM_CATALOG_DETAIL_LIST_SUCCESS, payload: data });
export const ComCatalogDetailListError = (error) => ({ type: COM_CATALOG_DETAIL_LIST_ERROR, payload: error });
export const ComCatalogDetailPageSet = (data) => ({ type: COM_CATALOG_DETAIL_PAGE_SET, payload: data });

// Catalog Detail Add
export const ComCatalogDetailAddModalSet = (data) => ({ type: COM_CATALOG_DETAIL_ADD_MODAL_SET, payload: data });
export const ComCatalogDetailAddChangeSet = (data) => ({ type: COM_CATALOG_DETAIL_ADD_CHANGE, payload: data });
export const ComCatalogDetailAdd = (data) => ({ type: COM_CATALOG_DETAIL_ADD, payload: data });
export const ComCatalogDetailAddSuccess = (data) => ({ type: COM_CATALOG_DETAIL_ADD_SUCCESS, payload: data });
export const ComCatalogDetailAddError = (error) => ({ type: COM_CATALOG_DETAIL_ADD_ERROR, payload: error });

// Catalog Detail Edit
export const ComCatalogDetailEditModalSet = (data) => ({ type: COM_CATALOG_DETAIL_EDIT_MODAL_SET, payload: data });
export const ComCatalogDetailEditSetData = (data) => ({ type: COM_CATALOG_DETAIL_EDIT_SET_DATA, payload: data });
export const ComCatalogDetailUpdate = (data) => ({ type: COM_CATALOG_DETAIL_UPDATE, payload: data });
export const ComCatalogDetailUpdateSuccess = (data) => ({ type: COM_CATALOG_DETAIL_UPDATE_SUCCESS, payload: data });
export const ComCatalogDetailUpdateError = (error) => ({ type: COM_CATALOG_DETAIL_UPDATE_ERROR, payload: error });

// Catalog Detail Cancel (Anular)
export const ComCatalogDetailCancelModalSet = (data) => ({ type: COM_CATALOG_DETAIL_CANCEL_MODAL_SET, payload: data });
export const ComCatalogDetailCancelSetData = (data) => ({ type: COM_CATALOG_DETAIL_CANCEL_SET_DATA, payload: data });

// Selector
const comCatalog = (state) => state[NAME];
export const ComCatalogSelector = createStructuredSelector({ comCatalog });
